import React from "react";

const CallIcon = ({ color = "#0B65B5" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.82888 14.671C3.67828 12.5163 2.02439 9.91767 0.982877 7.05702C0.409877 5.49302 0.934877 3.77502 2.11288 2.59702L2.84188 1.86902C3.03786 1.67264 3.27066 1.51684 3.52693 1.41053C3.78321 1.30423 4.05793 1.24951 4.33538 1.24951C4.61282 1.24951 4.88755 1.30423 5.14382 1.41053C5.4001 1.51684 5.63289 1.67264 5.82888 1.86902L7.53588 3.57602C7.73226 3.77201 7.88806 4.0048 7.99437 4.26108C8.10067 4.51735 8.15539 4.79208 8.15539 5.06952C8.15539 5.34697 8.10067 5.62169 7.99437 5.87797C7.88806 6.13424 7.73226 6.36704 7.53588 6.56302L7.11588 6.98302C6.94776 7.1511 6.8144 7.35065 6.72342 7.57028C6.63243 7.7899 6.5856 8.0253 6.5856 8.26302C6.5856 8.50075 6.63243 8.73615 6.72342 8.95577C6.8144 9.17539 6.94776 9.37494 7.11588 9.54302L10.9559 13.384C11.124 13.5521 11.3235 13.6855 11.5431 13.7765C11.7628 13.8675 11.9982 13.9143 12.2359 13.9143C12.4736 13.9143 12.709 13.8675 12.9286 13.7765C13.1482 13.6855 13.3478 13.5521 13.5159 13.384L13.9369 12.964C14.1329 12.7676 14.3657 12.6118 14.6219 12.5055C14.8782 12.3992 15.1529 12.3445 15.4304 12.3445C15.7078 12.3445 15.9825 12.3992 16.2388 12.5055C16.4951 12.6118 16.7279 12.7676 16.9239 12.964L18.6309 14.671C18.8273 14.867 18.9831 15.0998 19.0894 15.3561C19.1957 15.6124 19.2504 15.8871 19.2504 16.1645C19.2504 16.442 19.1957 16.7167 19.0894 16.973C18.9831 17.2292 18.8273 17.462 18.6309 17.658L17.9029 18.386C16.7249 19.565 15.0069 20.09 13.4429 19.517C10.5822 18.4755 7.98364 16.8216 5.82888 14.671Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CallIcon;
